import React from 'react'
import { Box } from '@mui/material'
import { formlessColors } from '@zuto/theme/src/mui/Colors'

export interface BrandStripHeaderProps {
  primaryLogo: React.ReactNode
  partnerLogo?: React.ReactNode
  topBorderColor?: string
  topBorderThickness?: number | string
  maxWidth?: number | string
  className?: string
}

const BrandStripHeader: React.FC<BrandStripHeaderProps> = ({
  primaryLogo,
  partnerLogo,
  topBorderColor = formlessColors.brandYellow,
  topBorderThickness = 4,
  maxWidth = 960,
  className
}) => {
  const hasPartner = Boolean(partnerLogo)

  return (
    <Box
      component="header"
      className={className}
      sx={{
        width: '100%',
        boxSizing: 'border-box',
        borderTop: `${topBorderThickness}px solid ${topBorderColor}`
      }}
    >
      <Box
        sx={{
          maxWidth,
          mx: 'auto',
          px: { xs: 5, lg: 0 },
          py: 4,
          display: 'flex',
          alignItems: 'center',
          justifyContent: hasPartner ? 'space-between' : 'flex-start',
          boxSizing: 'border-box'
        }}
      >
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center'
          }}
        >
          {primaryLogo}
        </Box>

        {hasPartner && (
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center'
            }}
          >
            {partnerLogo}
          </Box>
        )}
      </Box>
    </Box>
  )
}

export default BrandStripHeader
